import React, { useState, useEffect } from 'react';
import './App.css';
import Upload from './Upload';
import Input from './Input'; // Assuming you want to use 'Input' component
import { DICTIONARY } from './non-components/dictionary';
import Introduction from './Introduction';
import Guide from './guide'; // Assuming you want to use 'Guide' component

function Highlight(text) {
  return <span className="highlightme">{text}</span>;
}


function Organization(props) {
  if (
      !props.organizationname &&
      !props.organizationdisplayname &&
      !props.organizationurl &&
      !props.organizationname_sv &&
      !props.organizationdisplayname_sv &&
      !props.organizationurl_sv &&
      !props.organizationname_en &&
      !props.organizationdisplayname_en &&
      !props.organizationurl_en
  ) {
    return '';
  }

  let org = [`\n  <ns0:Organization>`];

  if (props.organizationname_sv) {
    org = [...org, '\n      <ns0:OrganizationName xml:lang="sv">', Highlight(props.organizationname_sv), `</ns0:OrganizationName>`];
  }
  if (props.organizationname_en) {
    org = [...org, '\n      <ns0:OrganizationName xml:lang="en">', Highlight(props.organizationname_en), `</ns0:OrganizationName>`];
  }

  if (props.organizationdisplayname_sv) {
    org = [...org, '\n      <ns0:OrganizationDisplayName xml:lang="sv">', Highlight(props.organizationdisplayname_sv), `</ns0:OrganizationDisplayName>`];
  }
  if (props.organizationdisplayname_en) {
    org = [...org, '\n      <ns0:OrganizationDisplayName xml:lang="en">', Highlight(props.organizationdisplayname_en), `</ns0:OrganizationDisplayName>`];
  }

  if (props.organizationurl_sv) {
    org = [...org, '\n      <ns0:OrganizationURL xml:lang="sv">', Highlight(props.organizationurl_sv), `</ns0:OrganizationURL>`];
  }
  if (props.organizationurl_en) {
    org = [...org, '\n      <ns0:OrganizationURL xml:lang="en">', Highlight(props.organizationurl_en), `</ns0:OrganizationURL>`];
  }

  return [...org, `\n  </ns0:Organization>`];
}


function Extension(props) {
  if (!props.scope) {
    return '';
  }

  return [
    '  <ns0:Extensions>\n      <shibmd:Scope regexp="false" xmlns:shibmd="urn:mace:shibboleth:metadata:1.0">',
    Highlight(props.scope),
    '</shibmd:Scope>\n  </ns0:Extensions>\n',
  ];
}


function parseEntityDesc(xmlDoc) {
  try {
    const para = xmlDoc.getElementsByTagNameNS('urn:oasis:names:tc:SAML:2.0:metadata', 'EntityDescriptor')[0];
    const elements = { entitydescriptor: { name: para.tagName, attributes: {} } };
    let xml_entity = `<${para.tagName}`;

    if (para.hasAttributes()) {
      const attrs = para.attributes;
      for (let i = attrs.length - 1; i >= 0; i--) {
        xml_entity += ` ${attrs[i].name}="${attrs[i].value}"`;
        elements.entitydescriptor.attributes[attrs[i].name] = attrs[i].value;
      }
    } else {
      console.log('No attributes to show');
    }
    xml_entity += '>\n';

    return { xml_entity, elements };
  } catch (error) {
    console.error('Error parsing XML:', error);
    return { xml_entity: '', elements: {} };
  }
}


export default function App() {
  const [xmlData, setXmlData] = useState({
    entity: '',
    ext: '',
    idp: '',
    org: '',
    close: '',
  });

  const [organizationData, setOrganizationData] = useState({
    organizationname: '',
    organizationdisplayname: '',
    organizationurl: '',
    organizationname_sv: '',
    organizationdisplayname_sv: '',
    organizationurl_sv: '',
    organizationname_en: '',
    organizationdisplayname_en: '',
    organizationurl_en: '',
  });

  const [scope, setScope] = useState('');

  const [uploaded, setUploaded] = useState(false);


  const updateXML = () => {
    let xml_org = Organization({
      organizationname: organizationData.organizationname,
      organizationdisplayname: organizationData.organizationdisplayname,
      organizationurl: organizationData.organizationurl,
      organizationname_sv: organizationData.organizationname_sv,
      organizationdisplayname_sv: organizationData.organizationdisplayname_sv,
      organizationurl_sv: organizationData.organizationurl_sv,
      organizationname_en: organizationData.organizationname_en,
      organizationdisplayname_en: organizationData.organizationdisplayname_en,
      organizationurl_en: organizationData.organizationurl_en,
    });

    let xml_ext = Extension({ scope: scope });

    setXmlData({
      ...xmlData,
      ext: xml_ext,
      org: xml_org,
    });
  };


  useEffect(() => {
    updateXML();
  }, [scope, organizationData]);


  const handleUpload = (stanza) => {
    if (!stanza) {
      setXmlData({
        entity: '',
        ext: '',
        idp: '',
        org: '',
        close: '',
      });
      setUploaded(false);
      return;
    }

    try {
      const xmlParser = new DOMParser();
      const xmlDoc = xmlParser.parseFromString(stanza, 'text/xml');

      const entityElement = xmlDoc.querySelector('EntityDescriptor'); // Replace 'ns0\\:EntityDescriptor' with the actual XML element name
      const { xml_entity } = parseEntityDesc(xmlDoc);

      const idpElement = entityElement.querySelector('IDPSSODescriptor'); // Replace 'ns0\\:IDPSSODescriptor' with the actual XML element name
      const xml_idp = new XMLSerializer().serializeToString(idpElement);

      const xml_ext = ""

      const xml_org = ""

      const xml_close = '</ns0:EntityDescriptor>';

       setXmlData({
        entity: xml_entity,
        ext: xml_ext,
        idp: xml_idp,
        org: xml_org,
        close: xml_close,
      });
      setUploaded(true);
    } catch (error) {
      console.error('Error parsing XML:', error);
    }
  };


  const handleInput = (event) => {
    const { name, value } = event.target;
    if (name === 'scope') {
      setScope(value);
    } else {
      setOrganizationData({
        ...organizationData,
        [name]: value,
      });
    }
  };

  return (
      <div className="layer0">
        <div className="layer1">
          {/*<div className="logo"></div>*/}
          {/*<div className="layer-input">*/}
          {/*  <div>*/}
          {/*    <Introduction />*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="layer-input">*/}
          {/*  <div>*/}
          {/*    <Guide />*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="layer-input">
            <div className="logo"></div>
            <hr className="my-2" />
            <h3 className="h3">{`${DICTIONARY.md_title.sv}`}</h3>
            {/*<p>{`${DICTIONARY.md_intro.sv}`}</p>*/}
            <div dangerouslySetInnerHTML={{ __html: DICTIONARY.md_intro.sv }} />
            <hr className="my-2" />
            <div className="xml-text" id="XMLdata">
              {[xmlData.entity, xmlData.ext, xmlData.idp, xmlData.org, xmlData.close]}
            </div>
            <div>
              <Upload onChange={handleUpload} uploaded={uploaded} />
            </div>
          </div>
          <div className="layer-input">
            {console.log(organizationData.organizationname_sv)}
            <Input
                onChange={handleInput}
                uploaded={uploaded}
                organizationname={organizationData.organizationname}
                organizationdisplayname={organizationData.organizationdisplayname}
                organizationurl={organizationData.organizationurl}
                organizationname_sv={organizationData.organizationname_sv}
                organizationdisplayname_sv={organizationData.organizationdisplayname_sv}
                organizationurl_sv={organizationData.organizationurl_sv}
                organizationname_en={organizationData.organizationname_en}
                organizationdisplayname_en={organizationData.organizationdisplayname_en}
                organizationurl_en={organizationData.organizationurl_en}
                scope={scope}
            />
          </div>
          <div>
            <Upload onChange={handleUpload} uploaded={uploaded} />
          </div>
        </div>
      </div>
  );
}
